import axios from 'axios'
import wx from 'weixin-js-sdk'
const UA = navigator.userAgent;

export function createUniqueId(hashLength) {
	hashLength = hashLength ? hashLength - 1 : 7;
	var ar = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
	var hs = [];
	var hl = Number(hashLength);
	var al = ar.length;
	var randomChar = String.fromCharCode(65+Math.ceil(Math.random() * 25));
	for (var i = 0; i < hl; i ++) {
		hs.push(ar[Math.floor(Math.random() * al)]);
	}
	return randomChar+hs.join('');
}

export function isWechat() {
	let ua = navigator.userAgent;
	return ua.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
}

export function isApp() {
	let ua = navigator.userAgent;
	if (/TheCover/i.test(ua)) {
		return true;
	}
	return false;
}

export function isCqrb() {
	return !!navigator.userAgent.toLowerCase().match('cqdaily')
}

export function isAndroid() {
	var ua = navigator.userAgent;
	if (/android/i.test(ua)) {
		return true;
	}
	return false;
}

export function getDeviceid() {
	var ua = navigator.userAgent;
	let step1 = ua.trim().split('(TheCover_');
	if(step1.length<2){
		return '';
	}else {
		return step1[1].split('_')[2].split(')')[0]
	}
}

export function getUrlParam() {
	let url = location.search;
	let theRequest = new Object();
	if (url.indexOf("?") != -1) {
		let str = url.substr(1);
		let strs = str.split("&");
		for(let i = 0; i < strs.length; i ++) {
			theRequest[strs[i].split("=")[0]]=unescape(strs[i].split("=")[1]);
		}
	}
	return theRequest;
}
export function getThemeType(path) {
	return  path.split('/')[1];
}

export function debounce(func, wait) {
	let timeout;
	return function () {
		let context = this;
		let args = arguments;
		if (timeout) clearTimeout(timeout);

		timeout = setTimeout(() => {
			func.apply(context, args)
		}, wait);
	}
}

export function configWXshare(shareObj) {
	//todo
	let link = 'https://ossapi.chuanbaoguancha.cn/weixin/mpjs/signature?url='+encodeURIComponent(location.href);
	axios.get(link).then(function (resp) {
		let shareData = {
			title: shareObj.share_title,
			desc: shareObj.share_desc,
			link: shareObj.share_link,
			imgUrl: shareObj.share_pic,
			success: function () {},
			cancel: function () {}
		};
		let data = resp.data;
		if (data.code > 0){
			wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: data.data.signature.appId, // 必填，公众号的唯一标识
				timestamp: data.data.signature.timestamp, // 必填，生成签名的时间戳
				nonceStr: data.data.signature.nonceStr, // 必填，生成签名的随机串
				signature: data.data.signature.signature,// 必填，签名，见附录1
				jsApiList: [
					'chooseImage', 'previewImage', 'uploadImage', 'downloadImage',
					'onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo',
					'openLocation', 'getLocation', 'hideOptionMenu', 'showOptionMenu',
					'translateVoice', 'startRecord', 'stopRecord', 'onRecordEnd',
					'playVoice', 'pauseVoice', 'stopVoice', 'uploadVoice','downloadVoice'
				] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
			});

			wx.ready(function(){
				// config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
				wx.onMenuShareTimeline(shareData);
				wx.onMenuShareWeibo(shareData);
				wx.onMenuShareAppMessage(shareData);
				wx.onMenuShareQQ(shareData);
				wx.onMenuShareQZone(shareData);
			});
		}
	})
}

export function forbidShare() {
	//todo
	let link = 'https://ossapi.chuanbaoguancha.cn/weixin/mpjs/signature?url='+encodeURIComponent(location.href);
	axios.get(link).then(function (resp) {
		let data = resp.data;
		if (data.code > 0){
			wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: data.data.signature.appId, // 必填，公众号的唯一标识
				timestamp: data.data.signature.timestamp, // 必填，生成签名的时间戳
				nonceStr: data.data.signature.nonceStr, // 必填，生成签名的随机串
				signature: data.data.signature.signature,// 必填，签名，见附录1
				jsApiList: ['hideMenuItems', 'hideOptionMenu', 'hideAllNonBaseMenuItem']// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
			});

			wx.ready(function(){
				wx.hideMenuItems({
					menuList: ['menuItem:share:qq',
						'menuItem:share:appMessage',
						'menuItem:share:timeline',
						'menuItem:copyUrl',
						'menuItem:openWithQQBrowser',
						'menuItem:openWithSafari',
						'menuItem:share:weiboApp',
						'menuItem:favorite',
						'menuItem:share:facebook',
						'menuItem:share:QZone'],
					// 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
					success: function (res) {}
				});
			});
		}
	})
}

export function downloadApp(id,flag){
	var cgId = id;//新闻稿子ID
	var cgFlag = flag;//新闻flag
	var nowTime = Date.now();
	var cbgcUL = "https://cbgcapi.scol.com.cn/UniversalLinks/index.html"
	var cbgcDownloadUrl = "https://a.app.qq.com/o/simple.jsp?pkgname=com.sichuanol.cbgc"
	var schemeurl = "chuanguan://com.sichuanol.cbgc/news?id=" +cgId+ "&flag=" +cgFlag;
	var universallink =	cbgcUL+ "?version=" +nowTime+ "&to=news&id=" +cgId+ "&flag=" +cgFlag;
	if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
		var loadDateTime = new Date();
		//window.location = "#";//schema链接或者universal link
		window.setTimeout(function() { //如果没有安装app,便会执行setTimeout跳转下载页
			var timeOutDateTime = new Date();
			if (timeOutDateTime - loadDateTime < 5000) {
				window.location = universallink; //ios下载地址
			} else {
				window.close();
			}
		}, 500);

	} else if (navigator.userAgent.match(/android/i)) {
		var state = null;
		try {
			//window.location = "#"; //schema链接或者universal link
			window.setTimeout(function() {
				window.location = cbgcDownloadUrl + "&android_schema=" + encodeURIComponent(schemeurl); //android下载地址
			}, 500);
		} catch (e) {}
	}
}

export function goAppLink(link) {
	var miyiDownloadUrl = "https://cbgc.scol.com.cn/miyi/download.html";
	var cbgcUL = "https://cbgcapi.scol.com.cn/UniversalLinks/index.html";
	var cbgcDownloadUrl =
		"https://a.app.qq.com/o/simple.jsp?pkgname=com.sichuanol.cbgc";
	// 调起APP或者去下载页
	function onGoApp(link) {
		// 不传参数就是去首页
		var toHomePage = true;
		if (arguments.length > 0) {
			toHomePage = false;
		}
		var onloadImg = function(url) {
			var img = new Image();
			img.src = url;
			img.onload = function() {};
		};
		var ua = navigator.userAgent;
		var isIos = false;
		var downloadlink = cbgcUL;
		var scheme = "chuanguan://com.sichuanol.cbgc";
		var nowTime = Date.now();
		if (/iphone/i.test(ua) || /ipad/i.test(ua) || /ipod/i.test(ua)) {
			isIos = true;
		}
		if (isIos) {
			var universallink =
				downloadlink +
				"?version=" +
				nowTime +
				"&to=link" +
				"&url=" + link;
			if (toHomePage) {
				universallink = downloadlink + "?version=" + nowTime;
			}
			console.log('universallink:', universallink);
			location.href = universallink;
		} else {
			var schemeurl = scheme + "/link?url=" + link;
			if (toHomePage) {
				schemeurl = scheme + "/open";
			}
			console.log('schemeurl:', schemeurl);
			window.location.href =
				cbgcDownloadUrl + "&android_schema=" + encodeURIComponent(schemeurl);
		}
	}
	onGoApp(link)
}


export function cbgcAnalyze(config){
	var para = {
		name:'cio',
		sdkUrl: 'https://dcdn.thecover.cn/cio/cover-track-cio.js',
		applicationId: "rmt_cbgc",
		...config
	}

	var p = para.sdkUrl, n = para.name, w = window, d = document,a=para.activeId,ap=para.applicationId,an=para.activeName?para.activeName:"", s = 'script',x = null,y = null;;
	w[n] = w[n] || function(a) {return function() {(w[n]._q = w[n]._q || []).push([a, arguments]);}};
	if (!w[n]._t) {
		x = d.createElement(s), y = d.getElementsByTagName(s)[0];
		x.async = 1;
		x.src = p+'?aid='+a+'&appid='+ap+'&an='+an;
		w[n].para = para;
		y.parentNode.insertBefore(x, y);
	}
}